"use strict";

class UraReportController {
    constructor($scope, $window, $timeout, SSHttpService, SSConfigService, SSAlertService, SSUtilService, OTPService, SSAppService, SSUserService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSConfigService = SSConfigService;
        self.SSAlertService = SSAlertService;
        self.SSUtilService = SSUtilService;
        self.OTPService = OTPService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.URA_REPORT_RESIDENTIAL_PROJECTS_TRANSACTIONS = SHOWSUITE.URA_REPORT_RESIDENTIAL_PROJECTS_TRANSACTIONS;
        self.URA_REPORT_RESIDENTIAL_PROJECTS_DEVELOPER_SALES = SHOWSUITE.URA_REPORT_RESIDENTIAL_PROJECTS_DEVELOPER_SALES;
        self.URA_REPORT_RESIDENTIAL_PROJECTS_IN_PIPELINE = SHOWSUITE.URA_REPORT_RESIDENTIAL_PROJECTS_IN_PIPELINE;
        self.URA_REPORT_RESIDENTIAL_PROJECTS_RENTAL_CONTRACT = SHOWSUITE.URA_REPORT_RESIDENTIAL_PROJECTS_RENTAL_CONTRACT;
        self.URA_REPORT_RESIDENTIAL_PROJECTS_RENTAL_MEDIAN = SHOWSUITE.URA_REPORT_RESIDENTIAL_PROJECTS_RENTAL_MEDIAN;

        self.init();

    }

    init() {
        const self = this;

        self.setPageOptions();
        self.setReporType();
        self.user = self.SSUserService.getUser();
        if (!self.user) {
            self.SSUserService.showLoginModal();
        }

        self.filters = {
            report_type: 1,
            offset: 0,
            limit: 5,
            send_total_count: 1
        };

        self.$timeout(function () {
            $("select.dashboard-select").niceSelect('update');
            jQuery('.datepicker2').datepicker({
                changeMonth: true,
                changeYear: true,
                yearRange: "1900:+0",
                dateFormat: "dd/mm/yy"
            });
        });

        self.ura_reports_history_master = null;

        self.pageNo = 1;
        self.current = 1;
        self.getURAReportData(self.pageNo)
    }

    getURAReportData(page) {
        const self = this;

        if(page) {
            self.current = page;
        }
        self.org_from_date = '';
        self.org_to_date = '';

        if(self.filters['from_date'])
        {
            self.org_from_date = self.filters['from_date'];
            self.filters['from_date'] = moment(self.filters['from_date'], "DD-MM-YYYY HH:mm:ss").format( "YYYY-MM-DD HH:mm:ss");
        }
        if(self.filters['to_date'])
        {
            self.org_to_date = self.filters['to_date'];
            self.filters['to_date'] = moment(self.filters['to_date'], "DD-MM-YYYY HH:mm:ss").format( "YYYY-MM-DD HH:mm:ss");
        }

        self.filters['offset'] = (page * self.filters['limit']) - self.filters['limit'];

        let url = 'sec/ura-reports/fetch-history';

        loading(true);

        self.SSHttpService.getAPIRequest(url, self.filters).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data) {

                self.filters['from_date'] = self.org_from_date;
                self.filters['to_date'] = self.org_to_date;

                self.ura_reports_history = response.data.ura_reports_history;
                self.total_count = response.data.count;
                self.ura_reports_history_master = angular.copy(self.ura_reports_history);
                self.ura_reports_history_backup = angular.copy(self.ura_reports_history);

                if(self.ura_reports_history.length == 0)
                {
                    self.ura_reports_history_master = null;
                }

                self.prepareNotificationsPaginationData();

            }
        });
    }

    updateRowLimit(){
        const self = this;

        self.filters['offset'] = 0;

        self.getURAReportData(1);
    }

    prepareNotificationsPaginationData() {
        const self = this;

         self.total_count  = Math.ceil(self.total_count / self.filters['limit']);

        self.brokerPagesArrayDisplay = [];
        self.brokerPagesArray = [];

        for (let i = 0; i < self.total_count; i++) {
            self.brokerPagesArray.push(i + 1);
        }

        for (let i = self.pageNo - 3; i <= self.pageNo ; i++) {
            if(i <= 0 )
                continue;
            self.brokerPagesArrayDisplay.push(i);
        }

        for (let j = self.pageNo + 1; j <= self.pageNo + 3; j++) {
            if(j > self.total_count)
                break;
            self.brokerPagesArrayDisplay.push(j);
        }

        if (self.total_count < self.pageNo) {
            self.pageNo = 1;
        }
    }

    setPageNonotifications(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.pageNo - 1;
            }

            if (pageNo > self.total_count) {
                pageNo = self.total_count;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.pageNo) {
                return; // Ignore if no change
            }

            self.pageNo = pageNo;
        }

        self.filters['offset'] = (self.pageNo - 1) * self.filters['limit'];

        self.getURAReportData(self.pageNo);
    }

    clearFilters() {
        const self = this;

        self.filters = {
            report_type: 1,
            offset: 0,
            limit: 5,
            send_total_count: 1
        };
        self.pageNo = 1;
        self.current = 1;

        self.getURAReportData(self.pageNo);
    }
    downloadReport(uraReportId) {
        const self = this;

        let url = 'sec/ura-reports/'+ uraReportId;

        url = self.SSHttpService.getApiURL(url);
        self.$window.location.href  = url;
        self.SSAlertService.success('Success!', 'URA report export successfully.');

    }
    setPageOptions(){
        const self = this;

        self.PAGE_OPTIONS = [
            {
                id: 5,
                name: 'View 5 Rows'
            },
            {
                id: 10,
                name: 'View 10 Rows'
            },
            {
                id: 50,
                name: 'View 50 Rows'
            },
            {
                id: 100,
                name: 'View 100 Rows'
            },
            {
                id: 1000,
                name: 'View 400 Rows'
            }
        ];
    }
    setReporType(){
        const self = this;

        self.reporType = [
            {
                id: 1,
                name: 'Private Residential Property Transactions'
            },
            {
                id: 2,
                name: 'Private Residential Property Units Sold by Developers'
            },
            {
                id: 3,
                name: 'Private Residential Properties in the Pipleline'
            },
            {
                id: 4,
                name: 'Private Residential Properties Rental Contract'
            },
            {
                id: 5,
                name: 'Private Non-Landed Residential Properties Median Rentals by Name'
            }
        ];
    }
    changeDate(date)
    {
        return moment(date, "YYYY-MM-DD HH:mm:ss").format( "DD-MM-YYYY HH:mm:ss");
    }
    
    getRepoerName(report_type)
    {
        const self = this;
        
        if(report_type == self.URA_REPORT_RESIDENTIAL_PROJECTS_TRANSACTIONS)
            return 'Private Residential Property Transactions';
        if(report_type == self.URA_REPORT_RESIDENTIAL_PROJECTS_DEVELOPER_SALES)
            return 'Private Residential Property Units Sold by Developers';
        if(report_type == self.URA_REPORT_RESIDENTIAL_PROJECTS_IN_PIPELINE)
            return 'Private Residential Properties in the Pipleline';
        if(report_type == self.URA_REPORT_RESIDENTIAL_PROJECTS_RENTAL_CONTRACT)
            return 'Private Residential Properties Rental Contract';
        if(report_type == self.URA_REPORT_RESIDENTIAL_PROJECTS_RENTAL_MEDIAN)
            return 'Private Non-Landed Residential Properties Median Rentals by Name';
    }


}

UraReportController.$inject = ['$scope', '$window', '$timeout', 'SSHttpService', 'SSConfigService', 'SSAlertService', 'SSUtilService', 'OTPService', 'SSAppService', 'SSUserService','SSConfirmationService'];
app.controller('UraReportController', UraReportController);


app.directive("datetimepicker", function () {

    function link(scope, element, attrs) {
        // CALL THE "datepicker()" METHOD USING THE "element" OBJECT.
        element.datetimepicker({
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
        });
    }

    return {
        require: 'ngModel',
        link: link
    };
});